import { useMemo } from 'react';

export const DEFAULT_EDIT_FIELDS = [
 { field: 'editUse', required: false },
 { field: 'editClass', required: false },
 { field: 'madeForRegions', required: false },
 { field: 'versionLanguages', required: false },
 { field: 'editDescription', required: false },
] as const;

export const fieldsByTitleType = {
	Movie: [
		{ field: 'title', required: true },
		{ field: 'workTypeDetail', required: true },
		{ field: 'titleLanguage', required: true },
		{ field: 'countriesOfOrigin', required: true },
		{ field: 'releaseDate', required: true },
		{ field: 'sortTitle', required: false },
		{ field: 'approximateLength', required: false },
		{ field: 'originalLanguages', required: true },
	],
	Compilation: [
		{ field: 'title', required: true },
		{ field: 'workTypeDetail', required: true },
		{ field: 'titleLanguage', required: true },
		{ field: 'releaseDate', required: true },
		{ field: 'sortTitle', required: false },
	],
	Season: [
		{ field: 'title', required: false },
		{ field: 'titleLanguage', required: true },
		{ field: 'countriesOfOrigin', required: true },
		{ field: 'releaseDate', required: true },
		{ field: 'sequenceNumber', required: true },
		{ field: 'sortTitle', required: false },
		{ field: 'approximateLength', required: false },
		{ field: 'originalLanguages', required: true },
	],
	Series: [
		{ field: 'title', required: true },
		{ field: 'titleLanguage', required: true },
		{ field: 'countriesOfOrigin', required: true },
		{ field: 'releaseDate', required: true },
		{ field: 'sortTitle', required: false },
		{ field: 'approximateLength', required: false },
		{ field: 'originalLanguages', required: true },
	],
	Episode: [
		{ field: 'sequenceNumber', required: true },
		{ field: 'title', required: false },
		{ field: 'workTypeDetail', required: true },
		{ field: 'titleLanguage', required: true },
		{ field: 'countriesOfOrigin', required: true },
		{ field: 'releaseDate', required: true },
		{ field: 'sortTitle', required: false },
		{ field: 'approximateLength', required: false },
		{ field: 'houseSequence', required: false },
		{ field: 'distributionNumber', required: false },
		{ field: 'originalLanguages', required: true },
	],
	Supplemental: [
		{ field: 'title', required: true },
		{ field: 'workTypeDetail', required: true },
		{ field: 'titleLanguage', required: true },
		{ field: 'countriesOfOrigin', required: true },
		{ field: 'releaseDate', required: true },
		{ field: 'sortTitle', required: false },
		{ field: 'approximateLength', required: false },
		{ field: 'originalLanguages', required: true },
	],
	 Edit: DEFAULT_EDIT_FIELDS,

	Manifestation: [
		{ field: 'platformSpecificationId', required: true },
		{ field: 'alid', required: true },
		{ field: 'madeForRegions', required: false },
	],
} as const;

export type FieldName = (typeof fieldsByTitleType)[keyof typeof fieldsByTitleType][number]['field'];

export type Fields = readonly { field: FieldName; required: boolean }[];

export function getFieldsByTitleTypeName(titleTypeName: string | undefined, includeDefaultEditFields = false): Fields {
 if (!titleTypeName) return [];
 const titleFields = fieldsByTitleType[titleTypeName as keyof typeof fieldsByTitleType];
 if (!titleFields) return [];
 if (!includeDefaultEditFields || titleTypeName === 'Edit') return titleFields;
 return [...titleFields, ...DEFAULT_EDIT_FIELDS];
}

function useFieldsByTitleTypeName(titleTypeName: string | undefined, includeDefaultEditFields = false): Fields {
 return useMemo(
  () => getFieldsByTitleTypeName(titleTypeName, includeDefaultEditFields),
  [titleTypeName, includeDefaultEditFields],
 );
}

export default useFieldsByTitleTypeName;
